export default function Footer() {
  return (
    <footer className="mt-12 text-center border-t border-light-text dark:border-dark-text py-4 text-sm">
      omkarprabhune.com © {new Date().getFullYear()}
    </footer>
  );
}
